export default "__VITE_ASSET__f82e6714__"